<form *ngIf="xPlatformRedirectUrl && errorMessage" #frm ngNoForm name="frm" id="frm" method="post" [action]="xPlatformRedirectUrl" target="_self">
    <input type="hidden" name="error" id="error" [value]="errorMessage" />
</form>
